module.exports = __webpack_public_path__ + "img/madden_conference-champs.3dc1e117.png";